<template>
  <modal
    class="editPumpStat pb-3"
    name="exportPdf"
    transition="pop-out"
    :width="570"
    :height="350"
  >
    <div class="modal__header">
      <h5 class="text-center text-white p-3">
        {{ $t("text.invoicesModal.export") }}
      </h5>
    </div>
    <div class="modal-form-wrapper mt-5">
      <div class="pb-3 text-center">
        <img
          src="https://next.waveapps.com/07f1c1778eee314dd7ef92c4d6bb94c0.png"
          class="download-icon"
        />
        <div class="text-center mt-4">
          {{ $t("text.invoicesModal.pdfInvoice") }}
        </div>
      </div>
    </div>
    <hr class="invoice_mod_hr" />
    <div class="text-right mr-3">
      <button class="invoice_btn" @click="hideModal">
        {{ $t("text.actionButtons.cancel") }}
      </button>
      <button class="invoice_btn colored" @click="downloadPdf()">
        {{ $t("text.invoicesModal.downloadPdf") }}
        <img
          src="@/assets/img/git_loader.gif"
          style="display: none"
          width="22px"
          class="ml-3 loader"
        />
      </button>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 850;
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  name: "exportPdf",
  props: ["id"],
  data() {
    return {
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      date: "",
      amount: null,
      paymentMethod: "selectMethod",
      memo: "",
      isButtonDisabled: false,
      invoiceDetails: {},
      invoiceStatus: null,
    };
  },
  watch: {},
  mounted() {
    this.getInvoice();
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    hideModal() {
      this.$modal.hide("exportPdf");
    },
    async getInvoice() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Invoices/${this.id}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.invoiceDetails = res.data;
          this.invoiceStatus = res.data.status;
        })
        .catch((error) => {});
    },
    downloadPdf() {
      $(".loader").show();
      this.axios({
        url: `${configObject.apiBaseUrl}/Invoices/Export-To-Pdf?id=${
          this.id
        }&markAsSent=${false}`,
        method: "GET",
        headers: configObject.authConfig().headers,
        responseType: "blob",
      })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "invoice.pdf");
          document.body.appendChild(fileLink);

          fileLink.click();

          this.$toast.open({
            message: this.$t("text.invoicesModal.successMsg"),
            type: "success",
            duration: 3000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$modal.hide("exportPdf");
        })
        .catch((e) => {
          $(".loader").hide();
          this.$toast.open({
            message: this.$t("text.invoicesModal.errorMsg"),
            type: "error",
            duration: 3000,
          });
        });
    },
  },
};
</script>
